import { BasketItemT } from '../../../../../@types/basketItem.type';
import { OrderSummaryItem } from '../../../../../components/pages/StepSummary/views/OrderSummaryItem';
import { useAppSelector } from '../../../../../config/hooks';
import { getPromoCode } from '../../../../../redux/selectors/basketSelector';
import { getSelectedCity } from '../../../../../redux/selectors/summaryReducer.selectors';
import {
  getPrice,
  getPricePerDay,
  getSelectedSideOrdersPrice,
} from '../../../../../utils/orderFormPrices';

type Props = {
  basket: Array<BasketItemT>;
};

const YourOrderInfoFE = ({ basket }: Props) => {
  const { code } = useAppSelector(getPromoCode) || {};
  const { sectorId } = useAppSelector(getSelectedCity) || {};

  return (
    <>
      {!!basket.length &&
        basket.map((item: BasketItemT) => {
          return (
            <OrderSummaryItem
              item={item}
              itemDietPrice={getPrice(item, code, sectorId)}
              itemDietPricePerDay={getPricePerDay(item, code, sectorId)}
              itemSideOrdersPrice={getSelectedSideOrdersPrice(
                item.mealExchange.days,
                item.sets
              )}
              key={item.orderId}
            />
          );
        })}
    </>
  );
};

export default YourOrderInfoFE;
